import * as Action from "@actions/index";
import * as Model from "@models/index";
import { useDispatch } from "@helpers/Store";

export default class Specialization {
  public static async load() {
    useDispatch(Action.Stand.Direction.setStatus("loading"));
    try {
      const response = await new Model.Company().specializations();
      useDispatch(Action.Stand.Specialization.setList(response.data));
      useDispatch(Action.Stand.Direction.setStatus("loaded"));
      return response.data;
    } catch (Exception) {}
  }
}
